import { QrViewerPrint } from './qr-viewer-print';
import { bindable } from 'aurelia-templating';
import { autoinject } from 'aurelia-dependency-injection';
import 'jquery.qrcode';

@autoinject()
export class QrViewer {

    public qrCodePrintableVM : QrViewerPrint;

    @bindable()
    source: string;

    @bindable()
    height: number | string;

    @bindable()
    width: number | string;

    @bindable()
    isPrintEnabled: boolean = false;

    @bindable()
    printableHeight: number | string;

    @bindable()
    printableWidth: number | string;

    @bindable()
    printStylesHref: string = "/styles/core.css";

    @bindable()
    logoSrc: string;

    @bindable()
    title: string;

    qrcode: any;
    qrcodePrintable: any;

    sourceChanged() {
        if (this.qrcode && this.source) {
            this.ensureDimensionsSet();
            const options: any = { text: this.source, width: this.width, height: this.height };
            $(this.qrcode)["qrcode"](options);
        }
    }

    attached() {
        this.sourceChanged();
    }

    private ensureDimensionsSet() {
        if (!this.width) {
            this.width = 64;
        }
        if (!this.height) {
            this.height = 64;
        }
    }

    public printCanvas(): void {
        if (this.qrCodePrintableVM) {
            this.qrCodePrintableVM.printPage();
        }
    }
}
